import axios from 'axios';

export const serverAddress = 'https://api.coeupdspadelhi.in/api';

export const USER_SIGN_IN = async (data) => {
    const url = `${serverAddress}/login`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_RESEARCH_LIST = async () => {
    const url = `${serverAddress}/research-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_NEW_RESEARCH = async (data) => {
    const url = `${serverAddress}/research-manage`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const RESEARCH_DELETE = async (data) => {
    const url = `${serverAddress}/research-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const DELETE_RESEARCH_GALLERY_IMAGE = async (data) => {
    const url = `${serverAddress}/research-gallery-delete`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const UPDATE_RESEARCH_STATUS = async (data) => {
    const url = `${serverAddress}/research-status`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_PROJECT = async (data) => {
    const url = `${serverAddress}/projects-manage`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_UPCOMMING_PROJECT = async (data) => {
    const url = `${serverAddress}/upcomming-project-manage`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_PROJECT_LIST = async () => {
    const url = `${serverAddress}/project-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const PROJECT_DELETE = async (data) => {
    const url = `${serverAddress}/projects-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_EVENT_LIST = async () => {
    const url = `${serverAddress}/events-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_EVENT = async (data) => {
    const url = `${serverAddress}/events-manage`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const UPDATE_EVENT_STATUS = async (data) => {
    const url = `${serverAddress}/events-status`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const EVENT_DELETE = async (data) => {
    const url = `${serverAddress}/events-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const EVENT_IMAGE_DELETE = async (data) => {
    const url = `${serverAddress}/events-delete-image`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_TEAM_TYPE = async (data) => {
    const url = `${serverAddress}/teams-manage`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_TEAM_TYPE_LIST = async () => {
    const url = `${serverAddress}/teams-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const TEAM_TYPE_DELETE = async (data) => {
    const url = `${serverAddress}/team-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_TEAM_MEMBER = async (data) => {
    const url = `${serverAddress}/team-member-manage`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const UPDATE_TEAM_MEMBER_STATUS = async (data) => {
    const url = `${serverAddress}/team-members-status`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_TEAM_MEMBER_LIST = async () => {
    const url = `${serverAddress}/team-members-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const TEAM_MEMBER_DELETE = async (data) => {
    const url = `${serverAddress}/team-member-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_COLLABORATION = async (data) => {
    const url = `${serverAddress}/collaborations-manage`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const UDPATE_COLLABORATION_STATUS = async (data) => {
    const url = `${serverAddress}/collaboration-status`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};


export const GET_ALL_COLLABORATION_LIST = async () => {
    const url = `${serverAddress}/collaborations-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const COLLABORATION_DELETE = async (data) => {
    const url = `${serverAddress}/collaboration-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_KREPO = async (data) => {
    const url = `${serverAddress}/repository-manage`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const UPDATE_KREPO_STATUS = async (data) => {
    const url = `${serverAddress}/repository-status`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_KREPO_LIST = async () => {
    const url = `${serverAddress}/repository-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const KR_DELETE = async (data) => {
    const url = `${serverAddress}/repository-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_BANNER = async (data) => {
    const url = `${serverAddress}/banner-manage`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const UPDATE_BANNER_STATUS = async (data) => {
    const url = `${serverAddress}/banner-status`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_BANNER_LIST = async () => {
    const url = `${serverAddress}/banner-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const BANNER_DELETE = async (data) => {
    const url = `${serverAddress}/banner-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_TRAINING_CATEGORY = async (data) => {
    const url = `${serverAddress}/training-categories-manage`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_TRAINING_CATEGORY_LIST = async () => {
    const url = `${serverAddress}/training-categories-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const TRAINING_CATEGORY_DELETE = async (data) => {
    const url = `${serverAddress}/training-categories-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_TRAINING = async (data) => {
    const url = `${serverAddress}/trainings-manage`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const UPDATE_TRAINING_STATUS = async (data) => {
    const url = `${serverAddress}/training-status`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_TRAINING_LIST = async () => {
    const url = `${serverAddress}/training-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const TRAINING_DELETE = async (data) => {
    const url = `${serverAddress}/trainings-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const TRAINING_PDF_DELETE = async (data) => {
    const url = `${serverAddress}/training-delete-pdf`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_VACANCIES = async (data) => {
    const url = `${serverAddress}/vacancies-manage`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_VACANCIES_LIST = async () => {
    const url = `${serverAddress}/vacancies-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const VACANCIES_DELETE = async (data) => {
    const url = `${serverAddress}/vacancies-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const UPDATE_VACANCIES_STATUS = async (data) => {
    const url = `${serverAddress}/vacancies-status`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ADD_ANNOUNCEMENT = async (data) => {
    const url = `${serverAddress}/announcement-manage`;

    const response = await axios
        .post(url, data,
            { headers: { "Content-Type": "multipart/form-data" }, }
        )
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const GET_ALL_ANNOUNCEMENT_LIST = async () => {
    const url = `${serverAddress}/announcement-list-admin`;

    const response = await axios
        .get(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const ANNOUNCEMENT_DELETE = async (data) => {
    const url = `${serverAddress}/announcement-delete/${data}`;

    const response = await axios
        .delete(url)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};

export const UPDATE_ANNOUNCEMENT_STATUS = async (data) => {
    const url = `${serverAddress}/announcement-status`;

    const response = await axios
        .post(url, data)
        .then(res => res?.data)
        .catch(err => err?.response?.data);
    return response;
};